import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.777 15.454a1 1 0 0 1 1 1V21a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4.546a1 1 0 0 1 1-1zM21 10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-7.777a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1zm-6.777 10H20v-8h-5.777zM2 20h5.777v-2.546H2zM8.777 0a1 1 0 0 1 1 1v11.516a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zM2 11.516h5.777V2H2zM21 0a1 1 0 0 1 1 1v6.06a1 1 0 0 1-1 1h-7.777a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm-6.777 6.06H20V2h-5.777z"
    }, null, -1)
  ]))]))
}
export default { render: render }